export default "__VITE_ASSET__Dn3DO2xZ__"